module.exports = __webpack_public_path__ + "prod/1.42.2/img/success-cases-four-bg.75e28660.png";